import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MAT_DIALOG_DEFAULT_OPTIONS, MatDialogRef } from '@angular/material/dialog';
import { faCalendarDays, faXmark } from '@fortawesome/pro-regular-svg-icons';
import { topazDefaultDialogOptions } from '@pearsonvue/topaz-angular-ui';

@Component({
  selector: 'app-announcement-dialogue',
  standalone: false,
  providers :[
    {
      provide: MAT_DIALOG_DEFAULT_OPTIONS,
      useValue: topazDefaultDialogOptions
    },
  ],
  templateUrl: './announcement-dialogue.component.html',
  styleUrl: './announcement-dialogue.component.scss'
})
export class AnnouncementDialogueComponent {
  icons = {
    faCalendarDays,
    faXmark
  }
  constructor (
    public dialogRef: MatDialogRef<AnnouncementDialogueComponent>,
     @Inject(MAT_DIALOG_DATA) public data: any, 
  ){}
  
}
